import { useCallback } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import ContentLoader from 'react-content-loader';

import TransactionList from './TransactionList';
import Paginate from '../../../components/Paginate';
import { useDict } from '../../../contexts/LanguageContext';

const ListTransaction = (props) => {
    const dict = useDict();
    const { transactionFilter, page, setPage, pageCount, isFetching } = props;

    const onPageChange = useCallback((event) => {
        setPage(event.selected + 1);
    }, []);

    const renderList = () => {
        if (isFetching) {
            return [...Array(4)].map((_, index) => (
                <ContentLoader
                    width="100%"
                    height="100"
                    gradientDirection="top-bottom"
                    backgroundColor="#eee"
                    foregroundOpacity={0.3}
                    className="mb-3"
                    key={`content-loader-${index}`}
                >
                    <rect width="100%" height="100%" y="0" rx="10" ry="10" />
                </ContentLoader>
            ));
        }

        return (
            <TransactionList
                transactionData={transactionFilter}
            />
        );
    };

    return (
        <div className="mx-2 d-flex flex-grow-1 flex-column">
            <div
                className="tabs tabs--bordered-bottom d-flex flex-grow-1 flex-column mb-4"
                style={{ overflowY: 'hidden' }}
            >
                <div className="tabs__wrap d-flex flex-grow-1 flex-column">
                    <Nav tabs className="mb-3">
                        <NavItem>
                            <NavLink className="active">
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        color: '#264391',
                                    }}
                                >
                                    {dict.history}
                                </span>
                            </NavLink>
                        </NavItem>
                    </Nav>
                    {renderList()}
                </div>
            </div>
            <Paginate
                pageCount={pageCount}
                onPageChange={onPageChange}
                forcePage={page - 1}
            />
        </div>
    );
};

export default ListTransaction;
